import { useEffect } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { leadpinSupabase } from '../services/leadpinSupabase'

export default function ShortLink() {
  const { shortId } = useParams()
  console.log('[ShortLink] MOUNT, shortId:', shortId, 'supabase:', !!leadpinSupabase)

  useEffect(() => {
    console.log('[ShortLink] EFFECT, shortId:', shortId)
    if (!shortId) return
    leadpinSupabase
      .rpc('track_short_id_click', { p_short_id: shortId })
      .then(res => console.log('[ShortLink] RPC OK:', res))
      .catch(err => console.error('[ShortLink] RPC ERR:', err))
  }, [shortId])
  
  return <Navigate to="/" replace />
}
